import { Skeleton } from "../../../../components/ui/common/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "../../../../components/ui/common/table";
import { cn } from "../../../../lib/utils";
import { UserRow } from "../../shared/types/user.types";
import UserTableRow from "./UserTableRow";
import { USER_TABLE_COLUMNS, userTableColumnClass } from "./userTable.columns";

const COLUMN_COUNT = USER_TABLE_COLUMNS.length + 1; // + actions column
const ROW_SKELETON_COUNT = 5;

interface UserTableProps {
  rows: UserRow[];
  isLoading: boolean;
  onView: (row: UserRow) => void;
  onEdit: (row: UserRow) => void;
  onDelete: (row: UserRow) => void;
}

/** Table shell styled after `CompanyTable` — card container, primary-tinted header, skeleton rows while loading. */
const UserTable = ({ rows, isLoading, onView, onEdit, onDelete }: UserTableProps) => (
  <div className="tw-relative tw-min-h-[280px] tw-overflow-x-auto tw-rounded-lg tw-border tw-border-border tw-bg-white">
    <Table className="tw-w-full tw-table-fixed [&_td]:tw-px-4 [&_td]:tw-py-3 [&_th]:tw-px-4 [&_th]:tw-py-3">
      <TableHeader>
        <TableRow className="tw-border-b-0 tw-bg-primary/5 hover:tw-bg-primary/5 [&_th]:tw-bg-primary/5 [&_th]:tw-text-primary [&_th]:tw-font-semibold [&_th]:tw-align-middle">
          {USER_TABLE_COLUMNS.map(column => (
            <TableHead key={column.key} className={cn(userTableColumnClass[column.key], "tw-text-primary")}>
              {column.label}
            </TableHead>
          ))}
          <TableHead className={cn(userTableColumnClass.actions, "tw-text-right tw-text-primary")}>
            Actions
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading ? (
          [...Array(ROW_SKELETON_COUNT)].map((_, index) => (
            <TableRow key={index} className="tw-bg-white">
              {[...Array(COLUMN_COUNT)].map((__, cellIndex) => (
                <TableCell
                  key={cellIndex}
                  className={
                    USER_TABLE_COLUMNS[cellIndex]
                      ? userTableColumnClass[USER_TABLE_COLUMNS[cellIndex].key]
                      : undefined
                  }
                >
                  <Skeleton className="tw-h-4 tw-w-full" />
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : rows.length === 0 ? (
          <TableRow className="tw-bg-white hover:tw-bg-white">
            <TableCell colSpan={COLUMN_COUNT} className="tw-py-12 tw-text-center tw-text-muted-foreground">
              No users found.
            </TableCell>
          </TableRow>
        ) : (
          rows.map(row => (
            <UserTableRow key={row._id} row={row} onView={onView} onEdit={onEdit} onDelete={onDelete} />
          ))
        )}
      </TableBody>
    </Table>
  </div>
);

export default UserTable;
